import defer from 'lodash/defer';
import {
  focusTrap,
  getTranslation,
  initObserveStore,
  observeStore,
  utils,
} from '@resy/ui-kitchen';
import getConnectedActions from '../../modules/actions/connectedActions';
import {
  getResyLocationsSelectedThunk,
  getResyLocationsThunk,
  setSelectedLocationThunk,
} from '../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import {
  getSelectedCoreISODateThunk, getSelectedCoreSeatsThunk, getSelectedCoreTimeThunk, setSelectedCoreISODate, setSelectedCoreSeats, setSelectedCoreTime,
} from '../../../../ui-kitchen/src/reducers/resyCoreSlice';
import { ISO_DATE_FORMAT } from '../../../../ui-kitchen/src/constants/resyCore';
import { selectIsAuthenticated } from '../../../../ui-kitchen/src/reducers/authTokenSlice';
import { generateNewSearchSessionThunk } from '../../../../ui-kitchen/src/reducers/venueSearchSlice';
import {
  getUserThunk, selectIsConcierge, selectIsGlobalDiningAccess, userLogoutThunk,
} from '../../../../ui-kitchen/src/reducers/userSlice';
import getLatLng from '../../../../ui-kitchen/src/utils/getLatLngThunk';
import Logger from '../../../../ui-kitchen/src/utils/logger';
import waitForImageToExist from '../../../../ui-kitchen/src/utils/waitForImageToExist';

angular.module('resyApp')
  .component('resyNav', {
    templateUrl: 'components/nav/nav.html',
    controller: ResyNavController,
    controllerAs: 'vm',
  });

function ResyNavController(
  $location,
  $rootScope,
  $scope,
  $route,
  $routeParams,
  $timeout,
  $translate,
  $window,
  Analytics,
  EventsCollectionId,
  ResyEvents
) {
  /* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["$rootScope"] }] */
  const vm = this;
  const store = $rootScope.reduxStore;
  const { dispatch, getState } = store;
  const {
    getResyConfigThunk,
  } = getConnectedActions(dispatch);
  const { venueInventoryUtils, checkIfType, getLocationSlug } = utils;
  const onVenueInventorySliceChange = (venueInventorySlice) => {
    vm.venueInventoryCache = venueInventorySlice.cache;
  };

  const observeVenueInventorySlice = initObserveStore(store, ({ venueInventory }) => venueInventory);
  const unsubscribeVenueInventory = observeVenueInventorySlice(onVenueInventorySliceChange);

  // Controls the display for all nav elements
  vm.dropdowns = {
    date: false,
    time: false,
    locations: false,
    menu: false,
    search: false,
    seats: false,
  };
  vm.isBackdropOpen = false;
  vm.showTimeFilter = true;

  // Location related
  vm.locations = [];
  vm.selectedLocation = null;
  vm.shouldHideLocation = false;
  vm.showSearch = true;

  // Auth/User related
  vm.isLoggedIn = false;
  vm.profilePhotoUrl = null;
  vm.isGda = false;
  vm.isConciergeUser = false;

  // Date & Seats
  // vm.searchFields is legacy at this point and should be refactored
  // I refactored out 'quantityStepper', so just 'datepicker' is left
  vm.searchFields = {
    datepicker: {
      model: null,
      config: {
        label: 'Pick a Date',
        calendarNumber: {
          default: 1,
          lg: 2,
        },
        calendarLeadDays: null,
      },
    },
  };
  vm.selectedSeats = null;
  vm.selectedTime = dispatch(getSelectedCoreTimeThunk());
  vm.calendar = null;
  let calendarLeadDays;

  // Search related
  vm.collections = undefined;
  vm.query = null;
  vm.selectedCollection = null;
  vm.selectedFacet = '';
  vm.shouldResetAutocompleteValue = false;
  vm.latLng = null;
  vm.autocompletePlaceholder = null;

  vm.$onInit = onInit;

  vm.onAutocompleteOpen = onAutocompleteOpen;
  vm.onCollectionSelect = onCollectionSelect;
  vm.onDateSelect = onDateSelect;
  vm.onTimeChange = onTimeChange;
  vm.onTimeClick = onTimeClick;
  vm.onFacetSelect = onFacetSelect;
  vm.onLocationsToggle = onLocationsToggle;
  vm.onLocationSelect = onLocationSelect;
  vm.onLogoClick = onLogoClick;
  vm.onPartySizeChange = onPartySizeChange;
  vm.onPartySizeClick = onPartySizeClick;
  vm.onQuery = onQuery;
  vm.onSuggestionSelect = onSuggestionSelect;
  vm.toggleCalendar = toggleCalendar;
  vm.closeCalendar = closeCalendar;
  vm.toggleMenu = toggleMenu;
  vm.closeEverything = closeEverything;
  vm.onLogin = onLogin;
  vm.onLogout = onLogout;
  vm.getAriaLabel = venueInventoryUtils.getAriaLabel;
  vm.ariaLabels = {
    mainResy: getTranslation({ translationKey: 'main_resy', fallback: 'Main Resy' }),
    close: getTranslation({ translationKey: 'close', fallback: 'Close' }),
    closeMenu: getTranslation({ translationKey: 'close_menu', fallback: 'Close menu' }),
    logoClickHome: getTranslation({ translationKey: 'resy_logo_click_home', fallback: 'Resy Logo. Click to go home.' }),
  };

  vm.clickableElementIdsToIgnore = ['DateSelector__button'];
  vm.hideSelectors = !!$rootScope.hideSelectors;
  vm.previewMode = !!$rootScope.previewMode;
  vm.searchPageSelectors = $rootScope.searchPageSelectors;
  vm.displayMobile = vm.hideSelectors || !vm.searchPageSelectors;

  $rootScope.toggleHideSelectors = () => {
    $rootScope.hideSelectors = !$rootScope.hideSelectors;
    vm.hideSelectors = $rootScope.hideSelectors;
    $rootScope.$digest();
  };

  $rootScope.setHideSelectors = (hide) => {
    $rootScope.hideSelectors = hide;
    vm.hideSelectors = $rootScope.hideSelectors;
    defer(() => $scope.$apply());
  };

  $rootScope.searchProps = {
    onDateSelect,
    onPartySizeChange,
    onPartySizeClick,
    onTimeChange,
    onTimeClick,
    toggleCalendar,
    onCollectionSelect,
    dropdowns: vm.dropdowns,
    searchFields: vm.searchFields,
    selectedSeats: vm.selectedSeats,
    selectedTime: vm.selectedTime,
  };

  function onInit() {
    setupReactors();
    loadUser();
    loadLocations();
    loadDate();
    loadPartySize();
    setMonthValues();
    loadAutocompletePlaceholder();
    processRouteParams($route.current.params);
  }

  const onCollectionsSliceChange = async (collections) => {
    const { lists } = collections;
    const selected = dispatch(getResyLocationsSelectedThunk());
    if (selected?.code) {
      const key = `${selected.code}-1-${selectIsAuthenticated(getState())}`;
      if (lists.all[key] && !lists.all[key]?.isLoading) {
        const { all } = lists?.all[key];
        vm.collections = await processCollections(selected.code, all);
        defer(() => $scope.$apply());
      } else {
        vm.collections = undefined;
      }
    }
  };

  const unsubscribeCollectionsSlice = observeStore(
    store,
    ({ collections }) => (collections),
    onCollectionsSliceChange
  );

  const onResyLocationsSliceChange = (resyLocations) => {
    const { selected } = resyLocations;
    vm.selectedLocation = selected;
    vm.shouldHideLocation = selected?.hideMenu;
    loadLatLng();

    if (!calendarLeadDays) {
      loadCalendarLeadDays();
    } else {
      assessCalendarLeadDays();
    }
    defer(() => $scope.$apply());
  };
  const observeResyLocationsSlice = initObserveStore(store, ({ resyLocations }) => (resyLocations));
  const unsubscribeResyLocationsSlice = observeResyLocationsSlice(onResyLocationsSliceChange);

  const onResyCoreSliceChange = (resyCoreSlice) => {
    const { selectedCoreISODate, selectedCoreSeats, selectedCoreTime } = resyCoreSlice;

    // SELECTED_TIME_UPDATED handling
    if (vm.selectedTime !== selectedCoreTime) {
      vm.selectedTime = selectedCoreTime;
      $rootScope.searchProps.selectedTime = vm.selectedTime;
    }

    // SELECTED_DATE_UPDATED handling
    // vm.searchFields.datepicker.model is a Date object
    // vm.selectedDateFormatted is in ISO date format
    // vm.activeMonthMomentObject is a Moment object
    // vm.searchFields.datepicker.config.label is in Calendar format
    if (vm.selectedDateFormatted !== selectedCoreISODate) {
      const selectedDate = moment(selectedCoreISODate, ISO_DATE_FORMAT).toDate();
      vm.searchFields.datepicker.model = selectedDate;
      vm.selectedDateFormatted = selectedCoreISODate;
      vm.activeMonthMomentObject = moment(selectedDate);
      vm.searchFields.datepicker.config.label = moment(selectedDate).calendar();
    }

    // PARTY_SIZE_SELECTED_UPDATED handling
    if (vm.selectedSeats !== selectedCoreSeats) {
      vm.selectedSeats = selectedCoreSeats;
      $rootScope.searchProps.selectedSeats = selectedCoreSeats;
    }
    defer(() => $scope.$apply());
  };
  const observeResyCoreSlice = initObserveStore(store, ({ resyCore }) => (resyCore));
  const unsubscribeResyCoreSlice = observeResyCoreSlice(onResyCoreSliceChange);

  let prevUserData = null;
  const onUserSliceChange = (userSlice) => {
    const { userData } = userSlice;
    vm.isConciergeUser = selectIsConcierge(getState());
    vm.isGda = selectIsGlobalDiningAccess(getState());
    vm.isLoggedIn = selectIsAuthenticated(getState());

    if (userData?.profile_image_url && prevUserData?.profile_image_url !== userData?.profile_image_url) {
      // Wait for the backend's background task to upload the photo to S3
      waitForImageToExist({
        src: userData.profile_image_url,
        retryDelay: 500,
        timeout: 5000,
        resolveWith: userData.profile_image_url,
      }).then((newImage) => {
        vm.profilePhotoUrl = newImage;
      });
    }

    // Angular 'UserAuth' event handling
    if (prevUserData === null && userData) {
      vm.profilePhotoUrl = userData.profile_image_url;
      closeEverything();
    }

    // Angular 'UserLogout' event handling
    if (prevUserData && userData === null) {
      vm.profilePhotoUrl = null;
    }

    prevUserData = userData;
    defer(() => $scope.$apply());
  };

  const observeUserSlice = initObserveStore(store, ({ user }) => (user));
  const unsubscribeUserSlice = observeUserSlice(onUserSliceChange);

  function getAnalyticsContext(pathname) {
    const HOMEPAGE = 'homepage';
    const SEARCH_PAGE = 'search page';
    let pageContext = utils.getPageContext(pathname);

    if (pageContext === HOMEPAGE) {
      pageContext = 'Home';
    } else if (pageContext === SEARCH_PAGE) {
      pageContext = 'Search';
    }

    return pageContext;
  }

  function shouldGoToSearchPage() {
    if (
      (checkIfType.isNullOrUndefined($route.current.params.location))
        || !(/\/cities\/([\w-]+)(\/search?)/).test(window.location.pathname)
        || (!checkIfType.isNullOrUndefined($route.current.params.location)
          && !checkIfType.isNullOrUndefined($route.current.params.venueSlug))
    ) {
      return true;
    }
    return false;
  }

  function onAutocompleteOpen() {
    onDropdownClick('search');
    defer(() => $scope.$apply());
  }

  function onCollectionSelect(item) {
    if (shouldGoToSearchPage() || !item) {
      $location.path(`cities/${vm.selectedLocation.url_slug}/search`);
    }

    if (item?.id === EventsCollectionId) {
      $location.path(`cities/${vm.selectedLocation.url_slug}/events`);
    } else if (item?.collectionSlug !== undefined) {
      $location.path(`cities/${vm.selectedLocation.url_slug}/list/${item.collectionSlug}`);
    }
    $location.search('facet', null);
    $location.search('query', null);
    closeEverything();
    defer(() => $scope.$apply());
  }

  async function onDateSelect(selectedDate, { usesBackdrop = true } = {}) {
    // selectedDate is a Moment object
    dispatch(setSelectedCoreISODate(selectedDate.format(ISO_DATE_FORMAT)));
    defer(() => Analytics.event('complete search', {
      context: getAnalyticsContext(window.location.pathname),
      'filter type': 'search filter',
      value: 'date',
      searchSessionId: getState().venueSearch.metadata.searchSessionId,
    }));
    if (usesBackdrop) {
      onDropdownClick('date');
    } else {
      defer(() => $scope.$apply());
    }
  }

  function onFacetSelect(facet) {
    if (shouldGoToSearchPage()) {
      $location.path(`cities/${vm.selectedLocation.url_slug}/search`);
    }
    $location.search('facet', facet || null);
    $location.search('query', null);

    closeEverything();
    defer(() => $scope.$apply());
    defer(() => Analytics.event('complete search', {
      context: getAnalyticsContext(window.location.pathname),
      'filter type': 'facet',
      value: facet,
      searchSessionId: getState().venueSearch.metadata.searchSessionId,
      engine: getState().venueSearch.metadata.lastUsedSearchEngine,
      suggestion: true,
    }));
  }

  function onLocationsToggle() {
    onDropdownClick('locations');
    defer(() => $scope.$apply());
  }

  function onLocationSelect(location) {
    const params = {
      location,
      $rootScope,
      $window,
    };
    dispatch(setSelectedLocationThunk(params));
    vm.selectedLocation = location;
    closeEverything();

    const locationSlug = getLocationSlug(location);
    $location.path(`/cities/${locationSlug}`);

    Analytics.event('change location', {
      context: getAnalyticsContext(window.location.pathname),
    });
  }

  function onLogoClick() {
    $location.search('query', null);
    $location.search('facet', null);
    $location.search('list', null);
    $location.path('/');
    closeEverything();
  }

  async function onPartySizeChange({ party_size: quantity }) {
    const pageContext = utils.getPageContext(window.location.pathname);
    const previousQuantity = vm.selectedSeats;

    if (!previousQuantity) return;
    if (String(previousQuantity) !== quantity) {
      dispatch(setSelectedCoreSeats(quantity));
      closeEverything();
      defer(() => $scope.$apply());
      defer(() => Analytics.event('complete search', {
        context: pageContext,
        'filter type': 'search filter',
        value: 'party size',
        searchSessionId: getState().venueSearch.metadata.searchSessionId,
      }));
    }
  }

  function onPartySizeClick() {
    onDropdownClick('seats');
  }

  function onTimeClick() {
    onDropdownClick('time');
  }

  async function onTimeChange({ time }) {
    if (time === null) return;
    const previousTime = vm.selectedTime;
    if (String(previousTime) !== time) {
      dispatch(setSelectedCoreTime(time));
      closeEverything();
      defer(() => $scope.$apply());
      defer(() => Analytics.event('complete search', {
        context: utils.getPageContext(window.location.pathname),
        'filter type': 'search filter',
        value: 'time',
        searchSessionId: getState().venueSearch.metadata.searchSessionId,
      }));
    }
  }

  function onQuery(query) {
    const searchPath = `/cities/${vm.selectedLocation.url_slug}/search`;
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.set('query', query);
    searchParams.delete('facet');

    const searchURL = `${searchPath}?${searchParams.toString()}`;

    /**
     * CON-15731 - Need to use $location.url here so that apostrophes in the
     * search params don't cause issues with AngularJS's routing
    */
    $location.url(searchURL);

    closeEverything();

    defer(() => $scope.$apply());

    setTimeout(() => {
      $rootScope.$broadcast('SEARCH_QUERY_TRIGGERED');
    }, 100);

    const pageContext = utils.getPageContext(window.location.pathname);
    /* Adding this timeout here is janky, but with the way that the Angular and
      Redux render cycles interact, there needs to be a delay here, or we will
      end up sending a stale searchSessionId.
    */
    setTimeout(() => {
      Analytics.event('complete search', {
        context: pageContext,
        'filter type': 'query',
        value: query,
        searchSessionId: getState().venueSearch.metadata.searchSessionId,
      });
    }, 250);
  }

  function onSuggestionSelect(item) {
    const pageContext = utils.getPageContext(window.location.pathname);
    if (item.facet) {
      onFacetSelect(`${item.type}:${item.value}`);
      return;
    }
    closeEverything();
    if (item?.isTockInventory) {
      utils.openTockUrl(item.tockBusinessPageUrl, $rootScope.reduxStore && $rootScope.reduxStore.dispatch);
      return;
    }
    $location.path(`cities/${item.location.urlSlug}/venues/${item.urlSlug}`);
    $location.search('list', null);

    vm.shouldResetAutocompleteValue = true;
    $timeout(() => {
      vm.shouldResetAutocompleteValue = false;
    });

    defer(() => $scope.$apply());

    dispatch(generateNewSearchSessionThunk());
    defer(() => Analytics.event('complete search', {
      context: pageContext,
      'filter type': 'suggestion',
      value: item.name,
      searchSessionId: getState().venueSearch.metadata.searchSessionId,
      engine: getState().venueSearch.metadata.lastUsedSearchEngine,
      suggestion: true,
    }));
  }

  function onDropdownClick(dropdown) {
    Object.keys(vm.dropdowns).forEach((key) => {
      if (key === dropdown) {
        vm.showSearch = true;
        const shouldOpen = !vm.dropdowns[key];
        vm.dropdowns[key] = shouldOpen;
        vm.isBackdropOpen = shouldOpen;
        $rootScope.isBackdropOpen = shouldOpen;

        if (shouldOpen) {
          if (dropdown === 'seats' || dropdown === 'time') {
            vm.isBackdropOpen = false;
            $rootScope.isBackdropOpen = false;
          } else if (dropdown === 'locations' && vm.dropdowns[key]) {
            vm.showSearch = false;
            focusTrap.focusModal('.LocationsMenu');
          } else if (dropdown === 'menu') {
            const isDesktop = document.querySelector('.MenuContainer--desktop');
            if (isDesktop) {
              focusTrap.focusModal(
                '.MenuContainer__menu-and-auth-button'
              );
            }
          }
        } else {
          focusTrap.focusRemove();
          if (dropdown === 'date') {
            // the date button re-renders, need a delay before setting focus
            setTimeout(() => document.querySelector('.ResyNav button.DateSelector')?.focus(), 350);
          }
        }
      } else {
        vm.dropdowns[key] = false;
      }

      defer(() => $scope.$apply());
    });
  }

  function toggleCalendar() {
    if (!vm.dropdowns.date) {
      onDropdownClick('date');
      // race condition, activeDate does not exist first time it is called. timeout gives it time to render for ada requirements. can be removed when react calendar is used instead
      setTimeout(handleFocus, 350);
    } else {
      closeCalendar();
    }
  }

  function closeCalendar() {
    vm.dropdowns.date = false;
    vm.isBackdropOpen = false;
    $rootScope.isBackdropOpen = false;
    defer(() => $scope.$apply());
  }

  function handleFocus() {
    const calendarContainer = document.querySelector('#ResyNav__calendar-dialog');
    const activeDate = document.querySelector('#active-date');

    if (calendarContainer && activeDate) {
      activeDate.focus();
    } else if (calendarContainer) {
      calendarContainer.focus();
    }
  }

  function toggleMenu() {
    onDropdownClick('menu');
    defer(() => $scope.$apply());
  }

  function closeEverything() {
    Object.keys(vm.dropdowns).forEach((key) => { vm.dropdowns[key] = false; });
    vm.showSearch = true;
    vm.isBackdropOpen = false;
    $rootScope.isBackdropOpen = false;
    focusTrap.focusRemove();
  }

  function onLogin() {
    closeEverything();
    $rootScope.$broadcast('MODAL', 'signin');
  }

  function onLogout() {
    dispatch(userLogoutThunk());
    closeEverything();
  }

  function setupReactors() {
    $scope.$on('$destroy', () => {
      unsubscribeVenueInventory();
      unsubscribeCollectionsSlice();
      unsubscribeResyCoreSlice();
      unsubscribeResyLocationsSlice();
      unsubscribeUserSlice();
    });

    $rootScope.$on('$routeChangeSuccess', (e, current, previous) => {
      closeEverything();
      processRouteParams(current.params);

      if (previous && 'pathParams' in previous) {
        // Navigating from venue page => somewhere else
        if ('venueSlug' in previous.pathParams) {
          vm.calendar = null;
        }

        // Navigating from search page => somewhere else
        if ('location' in previous.pathParams && !('venueSlug' in previous.pathParams)) {
          vm.shouldResetAutocompleteValue = true;

          $timeout(() => {
            vm.shouldResetAutocompleteValue = false;
          });
        }
      }
      vm.searchPageSelectors = $rootScope.searchPageSelectors;
      vm.hideSelectors = !!$rootScope.hideSelectors;
      vm.previewMode = !!$rootScope.previewMode;
      vm.displayMobile = vm.hideSelectors || !vm.searchPageSelectors;
    });

    $rootScope.$on('$routeUpdate', (e, current) => {
      processRouteParams(current.params);
    });
  }

  function setMonthValues(activeMonth) {
    const selectedMonth = activeMonth || moment(vm.selectedDateFormatted);
    const todaysDate = moment();
    vm.activeMonthMomentObject = moment(selectedMonth);

    vm.inventoryByDay = venueInventoryUtils.getDateRange(todaysDate);
    if (!$rootScope.$$phase) {
      defer(() => $scope.$apply());
    } else {
      setTimeout(() => $rootScope.$digest(), 50);
    }
  }

  function loadUser() {
    if (selectIsAuthenticated(getState())) {
      dispatch(getUserThunk(true));
    }
  }

  function loadLocations() {
    getResyConfigThunk()
      .then(() => dispatch(getResyLocationsThunk('nav')))
      .then((locations) => {
        vm.locations = locations;
        let selectedLocation;

        if ($routeParams.cities) {
          selectedLocation = locations.find((city) => city.code === $routeParams.cities);
          const params = {
            location: selectedLocation,
            $rootScope,
            $window,
          };
          dispatch(setSelectedLocationThunk(params));
        } else {
          selectedLocation = dispatch(getResyLocationsSelectedThunk());
        }

        if (selectedLocation) {
          vm.selectedLocation = selectedLocation;
          vm.shouldHideLocation = selectedLocation.hideMenu;
          loadLatLng();

          if (!calendarLeadDays) {
            loadCalendarLeadDays();
          } else {
            assessCalendarLeadDays();
          }
        }
        defer(() => $scope.$apply());
      });
  }

  async function processCollections(locationCode, collections) {
    if (!locationCode) {
      return undefined;
    }
    const payload = { limit: 1, locationId: locationCode };
    const eventsResponse = await ResyEvents.eventsByLocation(payload);
    const totalEvents = eventsResponse?.metadata?.total || 0;

    const filteredCollections = collections?.reduce((processedCollections, list) => {
      if (!totalEvents && list.id === EventsCollectionId) {
        return processedCollections;
      }

      processedCollections.push({
        id: list.id,
        type_id: list.info.type_id,
        name: list.info.short_name,
        collectionSlug: list.info.collection_slug,
        description: list.info.description,
        icon: list.info.image,
        isSelected: vm.selectedCollection === `collection_${list.id}`,
        urlSlug: `collection_${list.id}`,
      });
      return processedCollections;
    }, []);

    return filteredCollections;
  }

  function processRouteParams(params) {
    if ('list' in params) {
      vm.query = null;
      vm.selectedCollection = params.list;
      vm.selectedFacet = '';
      setSelectedCollection();
    } else if ('facet' in params) {
      vm.query = null;
      vm.selectedCollection = null;
      vm.selectedFacet = params.facet.split(':')[1]; // eslint-disable-line
    } else if ('query' in params) {
      vm.query = params.query;
    } else {
      vm.query = null;
      vm.selectedCollection = null;
      setSelectedCollection();
      vm.selectedFacet = '';
      vm.shouldResetAutocompleteValue = true;
      $timeout(() => {
        vm.shouldResetAutocompleteValue = false;
      });
    }
  }

  function loadDate() {
    const selectedCoreISODate = dispatch(getSelectedCoreISODateThunk());
    // date is an object
    vm.searchFields.datepicker.model = moment(selectedCoreISODate, ISO_DATE_FORMAT).toDate();
    vm.searchFields.datepicker.config.label = moment(selectedCoreISODate, ISO_DATE_FORMAT).calendar();
    vm.activeMonthMomentObject = moment(selectedCoreISODate, ISO_DATE_FORMAT);
    vm.selectedDateFormatted = selectedCoreISODate;
  }

  function loadCalendarLeadDays() {
    getResyConfigThunk('calendar')
      .then((calendar) => {
        if (!calendar) {
          return;
        }
        if ('num_days' in calendar && !!calendar.num_days) {
          calendarLeadDays = calendar.num_days;
          assessCalendarLeadDays();
        } else {
          Logger.log('Oops: why is config.calendar missing num_days?');
        }
        defer(() => $scope.$apply());
      });
  }

  function assessCalendarLeadDays() {
    if (calendarLeadDays[vm.selectedLocation?.code]) {
      vm.searchFields.datepicker.config.calendarLeadDays = calendarLeadDays[vm.selectedLocation.code];
    } else {
      vm.searchFields.datepicker.config.calendarLeadDays = 30;
    }
  }

  function loadPartySize() {
    vm.selectedSeats = dispatch(getSelectedCoreSeatsThunk());
  }

  function loadAutocompletePlaceholder() {
    $translate('search_restaurant_placeholder')
      .then((translation) => {
        vm.autocompletePlaceholder = translation;
      });
  }

  function loadLatLng() {
    dispatch(getLatLng())
      .then((data) => {
        const { value } = data;
        /**
         * This is garbage.
         * getLatLng() provides a specific data format
         * that should be refactored to be more generic and flexible --
         * if it is even still needed at all.
         * A further complexity is that it was quickly jammed
         * into other places in the app.
         */
        const [latitude, longitude] = value.replace(' ', '').split(',');
        vm.latLng = {
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude),
        };
        defer(() => $scope.$apply());
      });
  }

  function setSelectedCollection() {
    vm.collections?.forEach((list) => {
      list.isSelected = vm.selectedCollection === list.urlSlug; // eslint-disable-line
    });
  }
}

export default () => {};
